import {
  createInventoryAxiosClient,
  createLocationApiKeyAxiosClient,
  type InventoryAxiosClient,
} from '@/shared/api/default-axios-client';

export interface LocationInventoryStats {
  buildingsTotal: number;
  metersTotal: number;
}

interface CountResponse {
  meta?: {
    pagination?: {
      total?: number;
    };
  };
}

export class LocationInventoryStatsClient {
  private readonly axios: InventoryAxiosClient;

  constructor(input: { axiosClient?: InventoryAxiosClient } = {}) {
    this.axios = input.axiosClient ?? createInventoryAxiosClient();
  }

  async getStats(input: {
    locationApiKey: string;
    locationId: number;
    refreshCache?: boolean;
  }): Promise<LocationInventoryStats> {
    if (!this.axios.defaults.baseURL) {
      throw new Error('API base URL is required for location stats.');
    }

    const axios = createLocationApiKeyAxiosClient({
      axiosClient: this.axios,
      locationApiKey: input.locationApiKey,
      refreshCache: input.refreshCache,
    });
    const [buildings, meters] = await Promise.all([
      axios.get<CountResponse>('/inventory-location-buildings', {
        params: createLocationCountParams(input.locationId),
      }),
      axios.get<CountResponse>('/inventory-meters', {
        params: createLocationCountParams(input.locationId),
      }),
    ]);

    return {
      buildingsTotal: buildings.data.meta?.pagination?.total ?? 0,
      metersTotal: meters.data.meta?.pagination?.total ?? 0,
    };
  }
}

function createLocationCountParams(locationId: number) {
  return {
    'fields[0]': 'id',
    'filters[inventory_location][id][$eq]': locationId,
    'pagination[pageSize]': 1,
  };
}
